<template>
  <div>
    <div class="topbar" >
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript: window.history.go(-1)">返回</a>
        <h1>消息</h1>
      </div>
      <div class="liner"></div>
    </div>


    <mt-loadmore :top-method="loadTop" ref="loadmore">
    <div class="main-page news-list" v-infinite-scroll="loadBottom"
    infinite-scroll-disabled="isGetting"
    infinite-scroll-distance="150" style="padding-bottom:60px;">
      <div>
        <ul class="list-group-item primary">
          <li v-for="item in getPushInfo" class="list-group">
            <div class="liner"></div>
            <router-link class="group-link clearfix" :to="item.contentType == 22 ?  {path: '/user/center/NewsDetailInvitation/' + item.pushId} : {path: '/user/center/NewsDetail/' + item.pushId}">
              <span  class="pull-left img-wrap small"><img class="pull-left" :src="img_default" width="40"/></span>
              <span class="group-txt">
                <span class="block overhide">
                  <cite class="pull-left font-16">{{item.pushType == 1 ? '系统通知' : '消息通知'}}</cite>
                  <span class="pull-right gray font-12">{{item.pushDateString}}</span>
                </span>
                <cite class="con">{{item.pushContent}}</cite>
              </span>
              <i v-if="item.isRead == 0"></i>
            </router-link>
          </li>
          <li v-for="item in getBroadInfo" class="list-group">
            <div class="liner"></div>
            <router-link class="group-link clearfix" :to="{path: (item.contentType == 22 ? '/user/center/NewsDetailInvitation/' : '/user.center/NewsDetail/') + item.pushId}">
              <span class="img-wrap pull-left small"><img :src="img_default" width="100%"/></span>
              <span class="group-txt">
                <span class="block overhide">
                  <cite class="pull-left font-16">{{item.pushType==1 ? '系统通知' : '消息通知'}}</cite>
                  <span class="pull-right gray font-12">{{item.pushDateString}}</span>
                </span>
                <cite class="con">{{item.pushContent}}</cite>
              </span>
              <i v-if="item.field1 == 0"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    </mt-loadmore>
  </div>
</template>

<script>
import { service } from '../../service'
import { Toast } from 'mint-ui'

export default {
  data () {
    return {
      img_default: require('../../assets/images/img-default.png'),
      login_data: JSON.parse(window.localStorage['login_data']),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      get_push_list_para: service.setPara('getPushList'),
      get_broaad_list_para: service.setPara('getBroadCastList'),
      getPushInfo: [],
      getBroadInfo: [],
      isGetting: true, // 是否正在获取数据中
      isOver: false, // 是否是没有数据获取了
      isVisitor: false,
      type: 0
    }
  },
  mounted: function () {
    this.type = this.$route.params.type
    // 这是活获得广播消息
    // this.getBroadCastListMsg()
    this.get_push_list_para.offset = 0
    this.getPushListMsg()

    if (this.login_data.length <= 0) {
      this.isVisitor = true
    }
  },
  methods: {
    loadTop (id) {
      this.get_push_list_para.offset = 0
      this.isOver = false
      this.getPushInfo = []
      this.getPushListMsg()
      this.$refs.loadmore.onTopLoaded(id)
    },
    loadBottom (id) {
      if (this.isOver || this.isGetting) {
        return
      }
      this.get_push_list_para.offset++
      this.getPushListMsg()
    },
    getPushListMsg: function () {
      this.isGetting = true
      this.get_push_list_para.curcheId = this.cookie_login_data.curcheId
      this.get_push_list_para.userId = this.cookie_login_data.teacherId
      this.get_push_list_para.type = this.type

      let that = this
      let obj = {context: this, para: this.get_push_list_para, successFun: (response) => {
        that.isGetting = false
        if (response.data.length == 0) {
          that.isOver = true
        }
        var list = response.data
        that.getPushInfo = that.getPushInfo.concat(list)
      }}
      service.request(obj)
    },
    getBroadCastListMsg: function () {
      this.get_broaad_list_para.curcheId = this.cookie_login_data.curcheId
      this.get_broaad_list_para.userId = this.cookie_login_data.teacherId

      let that = this
      let obj = {context: this, para: this.get_broaad_list_para, successFun: (response) => {
        that.getBroadInfo = response.data
      }}
      service.request(obj)
    },
    showCurche: function () {
      Toast('亲爱的老师，您还没有加入任何园点，请联系管理员为您开通')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// NewsList.vue?791c044e